import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { ConfirmEditRepeatingTaskResult, getRepeatingTaskConfirmTopic, RequestShowConfirmEditRepeatingTaskModal } from '../messages';
import { CollaborationSidebarSessionId } from '../../../utils/magpie';
export function useConfirmEditRepeatingTaskModal() {
  "use memo";

  const $ = _c(10);
  const [reply, setReply] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const topic = getRepeatingTaskConfirmTopic();
      const unsubscribe = topic.on(RequestShowConfirmEditRepeatingTaskModal.getType(), (message, api) => {
        var _message$payload;
        const {
          sessionId
        } = (_message$payload = message.payload) !== null && _message$payload !== void 0 ? _message$payload : {};
        if (sessionId !== CollaborationSidebarSessionId) {
          return;
        }
        setReply(() => updateTemplate => {
          api.reply(ConfirmEditRepeatingTaskResult.create({
            updateTemplate
          }));
          setReply(null);
        });
      });
      return () => unsubscribe();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== reply) {
    t2 = () => {
      if (reply) {
        reply(null);
      }
      setReply(null);
    };
    $[2] = reply;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onClose = t2;
  let t3;
  if ($[4] !== reply) {
    t3 = t4 => {
      const {
        updateTemplate: updateTemplate_0
      } = t4;
      if (reply) {
        reply(updateTemplate_0 !== null && updateTemplate_0 !== void 0 ? updateTemplate_0 : false);
      }
      setReply(null);
    };
    $[4] = reply;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onDecisionMade = t3;
  const t4 = reply !== null;
  let t5;
  if ($[6] !== onClose || $[7] !== onDecisionMade || $[8] !== t4) {
    t5 = {
      show: t4,
      onClose,
      onDecisionMade
    };
    $[6] = onClose;
    $[7] = onDecisionMade;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}